<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="loadingReportesProgramadosAdd" size = "medium" color = "#fff" type = "ball-pulse" [fullScreen] = "false"><p style="color: white" class="text-center"> {{ fullScreenSpinnerMsg }} </p></ngx-spinner>

<p-dialog [(visible)]="repProgramadosService.modal_add0" [style]="{ width: '39%', 'font-size': '0.9rem' }">

  <ng-template pTemplate="header" class="p-dialog-title">
    <div>
      <i class="fa fa-plus me-2" aria-hidden="true"></i>
      <strong>Agregar Nuevo Reporte Programado</strong>
    </div>
  </ng-template>
  
  <ng-template pTemplate="body">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center" style="width: 70%;">
        <label class="fw-bold me-3">Reporte:</label>
        <div style="flex-grow: 1;">
          <p-dropdown 
            [options]="reports" 
            [(ngModel)]="selectedReport" 
            optionLabel="value" 
            [filter]="true" 
            filterBy="value" 
            filterPlaceholder="Buscar..." 
            emptyFilterMessage="No se encontró reporte para el filtro." 
            optionValue="codigo" 
            [appendTo]="'body'" 
            [showClear]="false" 
            placeholder="Seleccione el reporte..." 
            (onChange)="resetAllFields(); changedReport(); validateForm();"
            styleClass="p-dropdown-rounded">
          </p-dropdown>
        </div>
      </div>
      <p-button label="Agregar" icon="pi pi-plus" (click)="agregarReporteProgramado();" styleClass="p-button-secondary"></p-button>
    </div>
  </ng-template>
  
</p-dialog>
  

<p-dialog [(visible)]="repProgramadosService.modalReportesProgramadosActiveAddEdit" [style]="{ width: '50%', 'font-size': '0.9rem' }" [modal]="true" styleClass="p-fluid">

    <ng-template pTemplate="header" class="p-dialog-title" >
      <div>
          <i class="fa fa-plus me-2" aria-hidden="true" *ngIf="modal_add"></i>
          <i class="fa fa-edit me-2" aria-hidden="true" *ngIf="!modal_add"></i>
          <strong>{{repProgramadosService.titulo_modal_add_edit}}</strong>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
        <!-- <img [src]="'https://primefaces.org/cdn/primeng/images/demo/product/' + product.image" [alt]="product.image" class="block m-auto pb-3" *ngIf="product.image" /> -->
        
        <!-- <p-card> -->

          <!-- <ng-template pTemplate="header">
            <img alt="Card" src="https://primefaces.org/cdn/primeng/images/usercard.png" />
          </ng-template> -->

          <div class="row align-items-center">
            <!-- Etiqueta Reporte -->
            <div class="col-3 d-flex align-items-center text-start fw-bold">
                <label>Tipo de Reporte:</label>
            </div>
            
            <!-- Nombre del reporte -->
            <div class="col-6">
                <label>
                    <strong>{{form.nombre_reporte}}</strong>
                </label>
            </div>
        
            <!-- Checkbox Activo alineado -->
            <div class="col-3 d-flex align-items-center">
                <label class="me-2">Activo:</label>
                <p-checkbox inputId="binary" [binary]="true" [(ngModel)]="form.bol_activo"></p-checkbox>
            </div>
        </div>
        <br>

          <div class="row">
            <div class="col p-field">
              <label class="row ">
                <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  <label>Nombre del reporte:</label>
                </div>
                <div class="col-9 ">
                  <div class="gl-row-underline">
                    <input
                      type="text"
                      size="70"
                      placeholder="Nombre del reporte"
                      pInputText
                      [(ngModel)]="form.nombre_programacion"
                      required
                      #nombreProgramacion="ngModel"
                    />
                    <small class="text-danger" *ngIf="nombreProgramacion.invalid && nombreProgramacion.touched">
                      Este campo es obligatorio
                    </small>
                  </div>
                </div>
              </label>
            </div>
          </div>
          
          <br>

          <div class="row">
            <div class="col-6">
              <div class="p-field">
              <label class="bg-subtitle" id="filtrado_label">Filtrar por:</label>
              <p-dropdown [options]="listOptions" [(ngModel)]="listOptionCheckbox" [showClear]="false" optionLabel="idOption" optionValue="valueOption" (onChange)="onOptionSelected();validateForm();" [disabled]="reportService.workingOnReport"></p-dropdown>
              </div>
            </div>
            <div class="col-6" *ngIf="listOptionCheckbox=='operacion' || listOptionCheckbox=='convoy'">
              <div class="p-field">
                <label class="bg-subtitle" id="operation_label">Operaciones:</label>
                <p-dropdown [options]="operations" [(ngModel)]="selectedOperation" [showClear]="true"  optionLabel="nameoperation" optionValue="idoperation" (onChange)="onChangeOperation();validateForm();"  [placeholder]="placeholderOperation" [disabled]="reportService.workingOnReport || disabledOperation"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6" *ngIf="listOptionCheckbox=='grupo'">
              <div class="p-field">
                <label class="bg-subtitle" id="operation_label">Operaciones:</label>
                <p-dropdown [options]="operations" [(ngModel)]="selectedOperation" [showClear]="true" optionLabel="nameoperation" optionValue="idoperation" (onChange)="onChangeOperation();validateForm();"  [placeholder]="placeholderOperation"  [disabled]="reportService.workingOnReport || disabledOperation"></p-dropdown>
              </div>
            </div>
            <div class="col-6" *ngIf="listOptionCheckbox=='grupo' || listOptionCheckbox=='convoy'">
              <div class="p-field">
                <label class="bg-subtitle" id="grupo_label">Grupos:</label>
                <p-dropdown [options]="groups" [(ngModel)]="selectedGroup" [showClear]="true" optionLabel="namegrupo" optionValue="idgrupo" (onChange)="onChangeGroup();validateForm(); " [placeholder]="placeholderGroup" [disabled]="reportService.workingOnReport || disabledGroup"></p-dropdown>
              </div>
            </div>
            <div class="col-6" *ngIf="listOptionCheckbox=='convoy'">
              <div class="p-field">
                <label class="bg-subtitle" id="grupo_label">Convoys:</label>
                <p-dropdown [options]="convoys" [(ngModel)]="selectedConvoy" [showClear]="true" optionLabel="nameconvoy" optionValue="idconvoy" (onChange)="onChangeConvoy();validateForm();" [placeholder]="placeholderConvoy" [disabled]="reportService.workingOnReport || disabledConvoy"></p-dropdown>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="p-field">
                <label class="bg-subtitle" id="vehicle_label">Vehículos:</label>
                <p-multiSelect [options]="vehicles" [(ngModel)]="selectedVehicles" optionLabel="name" [showToggleAll]="true" [appendTo]="'body'" placeholder="Seleccione..." [selectedItemsLabel]="'{0} vehiculos seleccionados'"
                (onChange)="onSelectedVehiclesChange(); validateForm();" [disabled]="reportService.workingOnReport"></p-multiSelect>
                <div style="padding: 0px 0.3rem; margin-top: 0.25rem; text-align: right;">
                  <!-- <label class="png-checkbox-container d-flex align-items-center gap-1 ps-1"> -->
                  
                </div>
    
              </div>
            </div>
          </div>
          <br>

          <div class="row" *ngIf="showLimitTime">
            <div class="col p-field">
              <label class="row ">
                <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  <label>Hora del día:</label>
                </div>
                <div class="col-9 d-flex">
                  <input
                    type="time"
                    pInputText
                    [(ngModel)]="form.hora_inicio"
                    name="horaInicio"
                    required
                    #horaInicio="ngModel"
                  />
                  <span class="mx-2">-</span>
                  <input
                    type="time"
                    pInputText
                    [(ngModel)]="form.hora_fin"
                    name="horaFin"
                    required
                    #horaFin="ngModel"
                  />
                </div>
                <small class="text-danger" *ngIf="(horaInicio.invalid || horaFin.invalid) && (horaInicio.touched || horaFin.touched)">
                  Ambas horas son obligatorias.
                </small>
              </label>
            </div>
          </div>
          

          <!-- <div>-----------------------------------------------------------</div> -->

          <div class="row">
            <div class="col p-field">
              <label class="row ">
                  <div class="col-12 ">
                      <div class="gl-row-underline">
                        <label></label>
                      </div>
                  </div>
              </label>
            </div>
          </div>
          <br>


          <div class="row" style="padding: 0px 0.3rem">
            <div class="col-6">
              <label>
                <p-checkbox name="groupname" [binary]="true" [(ngModel)]="form.p_chkDateHour" (onChange)="onChkDateHourChange(); validateForm();"></p-checkbox>
                Fecha/Hora</label>
            </div>
          </div>

          <br>

          <div class="row" style="padding: 0px 0.3rem">
       
            <ng-container *ngIf="showMovStop">
            <!-- <ng-container *ngIf="true"> -->

              <div class="col-6">
                <div class="p-field">
                  <label>
                    <p-checkbox [(ngModel)]="form.p_chkStops" [binary]="true" inputId="binary" (onChange)="validateForm();" [disabled]="workingOnReport"></p-checkbox>
                  Paradas</label>
                </div>
              </div>
              <div class="col-6">
                <div class="p-field">
                  <label>
                    <p-checkbox [(ngModel)]="form.p_chkMovements" [binary]="true" inputId="binary" (onChange)="validateForm();" [disabled]="workingOnReport"></p-checkbox>
                  Movimientos</label>
                </div>
              </div>
            </ng-container>

          </div>


          <div *ngIf="showExcVelOpt">
          <!-- <div *ngIf="true"> -->

            <div class="row">
              <div class="p-field">
                <div class="d-flex p-dropdown-full-width">
                  <p-dropdown [options]="pDropdownDuration" [(ngModel)]="form.p_checkboxDuration" [showClear]="false" optionLabe="label" optionValue="value" (onChange)="validateForm();" [styleClass]="'bg-subtitle'" [disabled]="workingOnReport"></p-dropdown>
                </div>
                <p-inputNumber *ngIf="!checkboxDuration" [(ngModel)]="form.p_limitSpeed" [showButtons]="true" [min]="0" [max]="300" suffix=" km/h" inputId="limiteVelocidad" [disabled]="workingOnReport"></p-inputNumber>
                <p-inputNumber *ngIf="checkboxDuration" [(ngModel)]="form.p_minimDur" [showButtons]="true" [min]="0" suffix=" seg" inputId="minimaDuracion" [disabled]="workingOnReport"></p-inputNumber>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showZones">
          <!-- <div class="row" *ngIf="true"> -->
            <div class="p-field">
              <label class="bg-subtitle" id="zone_label">Geocercas :</label>
              <p-multiSelect [options]="zones" [(ngModel)]="form.p_zonas" optionLabel="zone_name" optionValue="id" [showToggleAll]="false" [appendTo]="'body'" placeholder="Seleccione la(s) geocerca(s)" (onChange)="onSelectedGeofenceschange(); validateForm();" [disabled]="workingOnReport"></p-multiSelect>
              <div style="padding: 0px 0.3rem; margin-top: 0.25rem; text-align: right;">
                <label>
                  <p-checkbox [(ngModel)]="chkAllZones" [binary]="true" inputId="binary" (onChange)="selectAllZones(); validateForm();" [disabled]="!areZonesLoaded || workingOnReport"></p-checkbox>
                  Todos
                </label>
              </div>
            </div>
          </div>





          <div class="row two-column-checkbox-container" *ngIf="showTipoExcesoVelocidad">
          <!-- <div class="row two-column-checkbox-container" *ngIf="true"> -->

            <div class="col-12">
              <label class="bg-subtitle">Seleccione el tipo de reporte de exceso:</label>
            </div>
    
            <div class="col-12 d-flex flex-column gap-2 py-3" style="padding: 0rem 1.25rem;">
              <div class="row">
                <div class="col-6">
                  <div class="p-field">
                    <label class="bg-subtitle" >Duración:</label>
                    <!-- <p-dropdown [options]="listOptionsDuracion" [(ngModel)]="selectedDuracion" [showClear]="false" optionLabel="" optionValue="valueOption" (onChange)="onOptionSelected();validateForm();" [disabled]="workingOnReport"></p-dropdown> -->
                    <p-dropdown [options]="listOptionsDuracion" [(ngModel)]="form.p_selectedDuracion" optionLabel="name" [showClear]="true"  (onChange)="onchangeDuracion();" placeholder="Seleccionar Duración"></p-dropdown>
                  </div>
                </div>
                <div class="col-6">
                  <div class="p-field">
                    <label class="bg-subtitle" >Tolerancia:</label>
                    <p-dropdown [options]="listOptionsToleracia" [(ngModel)]="form.p_selectedToleracia" optionLabel="name" [showClear]="true" placeholder="Selecciona Tolerancia"></p-dropdown>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                    <div class="p-field">
                        <label><p-checkbox name="groupname" [binary]="true" [(ngModel)]="form.p_chkRiesgo"></p-checkbox>Nivel de Riesgo</label>
                    </div>
                </div>
                <div class="col-6" >
                </div>
              </div>
            </div>
    
          </div>
          <!--ESTE ES OTRO CAMPO -->
          <div class="row two-column-checkbox-container" *ngIf="showCheckboxs">

            <div class="col-12">
              <label class="bg-subtitle">Seleccione las opciones a incluir en el reporte:</label>
            </div>
    
            <div class="col-12 d-flex flex-column gap-2 py-3" style="padding: 0rem 1.25rem;">
    
              <div class="row">
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.fServidor" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    Fecha Servidor</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.pCercano" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Punto Cercano</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.velCAN" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Velocidad CAN</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.velGPS" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Velocidad GPS</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.velGPS_speed" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Velocidad GPS_speed</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.velMobileye_ME460" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Velocidad Mobileye</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.velECO" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Velocidad ECO</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.DUOT2state" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    DUOT2 state</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.RxM" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      RPM</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.RPMAlta" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      RPM Alta</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.cNivel" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Nivel de Combustible</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.cRestante" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Combustible Restante</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.cMotor" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Consumo de Motor</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.odometro" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Odómetro</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.altitud" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Altitud</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.angulo" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Angulo</label>
                  </div>
                </div>
                <!-- ALIMENTACION GPS -->
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.alimentGps" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Alimentación GPS</label>
                  </div>
                </div>
                <!-- NIVEL DE BATERIA -->
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.nivelBateria" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Nivel de batería</label>
                  </div>
                </div>
                <!-- NIVEL DE COBERTURA -->
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.nivelCobertura" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Nivel de cobertura</label>
                  </div>
                </div>
                <!-- NIVEL DE TEMPERATURA GPS -->
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.temperaturaGps" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Temperatura GPS</label>
                  </div>
                </div>
                <!-- SATELITE -->
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.satelite" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Satélite</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.recFacial" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Reconocimiento Facial</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.onOff" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    Ignición</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.alcoholemia" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    Alcoholemia</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.parametros" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    Parámetros</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.ubicacion" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                      Ubicación</label>
                  </div>
                </div>
                <div class="col-6" style="margin-top: 5px">
                  <div class="p-field">
                    <label>
                      <p-checkbox [(ngModel)]="oG.referencia" [binary]="true" inputId="binary" [disabled]="reportService.workingOnReport"></p-checkbox>
                    Referencia</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <div class="row" *ngIf="showEvents || showEventsCipia || showAtencionEventsCipia">
        <div class="p-field">
          <label class="bg-subtitle" id="tag_label">Etiquetas de Geocercas :</label>
          <p-multiSelect [options]="repProgramadosService.listTags" [(ngModel)]="form.p_tags_zonas" optionLabel="var_name" optionValue="id" [showToggleAll]="false" [appendTo]="'body'" placeholder="Seleccione la(s) etiqueta(s)" (onChange)="onSelectedTagschange(); validateForm();" [disabled]="workingOnReport"></p-multiSelect>
          <div style="padding: 0px 0.3rem; margin-top: 0.25rem; text-align: right;">
            <label>
              <p-checkbox [(ngModel)]="chkAllTags" [binary]="true" inputId="binary" (onChange)="selectAllTags(); validateForm();" [disabled]="workingOnReport"></p-checkbox>
              Todos
            </label>
          </div>
        </div>
      </div>

      <br>

      <div class="row two-column-checkbox-container"  *ngIf="showEvents || showEventsCipia || showAtencionEventsCipia">
        <!-- Encabezado con icono interactivo -->
        <div class="col-12 d-flex align-items-center justify-content-between bg-subtitle" style="cursor: pointer;" (click)="toggleEvents()">
          <label class="m-0">Seleccione los eventos a incluir en el reporte:</label>
          <div class="d-flex flex-column align-items-center">
            <i [ngClass]="showEventList ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
            <div style="width: 20px; height: 2px; background: black; margin-top: 2px;"></div>
          </div>
        </div> <br>
      
        <!-- Contenido que se oculta o muestra -->
        <div *ngIf="showEventList" class="col-12 d-flex flex-column gap-2 py-3" style="padding: 0rem 1.25rem;">
          <ng-container *ngFor="let type of repProgramadosService.eventsTypes">
            <ng-container *ngIf="type.active">
              <div class="row">
                <div class="col-12">
                  <label class="bg-subtitle bg-subtitle-light">Eventos{{ type.label }}</label>
                </div>
              </div>
              <div class="row">
                <ng-container *ngFor="let event of repProgramadosService.events">
                  <ng-container *ngIf="event.event_category == type.name">
                    <div class="col-6" style="margin-top: 5px">
                      <div class="p-field">
                        <label>
                          <p-checkbox [(ngModel)]="event.active" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="workingOnReport"></p-checkbox>
                          {{ event.name_event }}
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div> <br>

            <div class="row two-column-checkbox-container" *ngIf="showAtencionEventsCipia">
              <div class="col-12">
                <label class="bg-subtitle">Seleccione las opciones a incluir en el reporte:</label>
              </div>
      
              <div class="col-12 d-flex flex-column gap-2 py-3" style="padding: 0rem 1.25rem;">
      
         
                <div class="row">
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Fecha" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Fecha</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.FechaServidor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Fecha Servidor</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.NombreEvento" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Nombre del Evento</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Evento" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Descripción</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Codigo" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Código</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Placa" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Placa</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.TipoUnidad" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Tipo de Unidad</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.IdConductor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        ID Conductor</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Conductor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Conductor</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.FechaEvaluacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Fecha de Evaluación</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.CriterioEvaluacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Criterio de Evaluación</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Observacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Observación</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Validacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Validación</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                        <label>
                          <p-checkbox [(ngModel)]="eC.VelCAN" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                          Vel. CAN</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                        <label>
                          <p-checkbox [(ngModel)]="eC.VelGPS" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                          Vel. GPS</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                        <label>
                          <p-checkbox [(ngModel)]="eC.VelMobileye" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                          Vel. Mobileye</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                        <label>
                          <p-checkbox [(ngModel)]="eC.VelECO" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                          Vel. ECO</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Zona" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Geocerca</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.PuntoCercano" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Punto Cercano</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Ubicacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Ubicación</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.Referencia" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Referencia</label>
                    </div>
                  </div>
      
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.OperadorMonitoreo" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Operador de Monitoreo</label>
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.EnlaceArchivo" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Enlace a Archivo</label>
                      <!-- <label>
                        <p-checkbox [(ngModel)]="eC.VelGPSspeed" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                        Vel. GPS speed</label> -->
                    </div>
                  </div>
                  <div class="col-6" style="margin-top: 5px">
                    <div class="p-field">
                      <label>
                        <p-checkbox [(ngModel)]="eC.ComRadial" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()"
                          [disabled]="reportService.workingOnReport"></p-checkbox>
                        Comunicación radial</label>
                    </div>
                  </div>
      
                </div>
      
              </div>
            </div>





            <!--PRIMERA -->
      <div class="row two-column-checkbox-container" *ngIf="showEvents || showEventsCipia">
        <div class="col-12 d-flex align-items-center justify-content-between bg-subtitle" style="cursor: pointer;" (click)="toggleOptions()">
          <label class="m-0">Seleccione las opciones a incluir en el reporte:</label>
          <div class="d-flex flex-column align-items-center">
            <i [ngClass]="showOptionsList ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
            <div style="width: 20px; height: 2px; background: black; margin-top: 2px;"></div>
          </div>
        </div>
        <br>

        <div class="col-12 d-flex flex-column gap-2 py-3" style="padding: 0rem 1.25rem;">

   
          <div class="row">
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Fecha" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Fecha</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.FechaServidor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Fecha Servidor</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.NombreEvento" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Nombre del Evento</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Evento" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Descripción</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Codigo" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Código</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Placa" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Placa</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.TipoUnidad" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Tipo de Unidad</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.IdConductor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  ID Conductor</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Conductor" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Conductor</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.VelMobileye" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Vel. Mobileye</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.VelGPS" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Vel. GPS</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.VelGPSspeed" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Vel. GPS speed</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.VelCAN" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Vel. CAN</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.VelECO" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Vel. ECO</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Zona" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Geocerca</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.PuntoCercano" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Punto Cercano</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Ubicacion" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Ubicación</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Referencia" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Referencia</label>
              </div>
            </div>
            <div class="col-6" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.EnlaceArchivo" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Enlace a Archivo</label>
              </div>
            </div>
            <div class="col-6" *ngIf="selectedReport == 'R040'" style="margin-top: 5px">
              <div class="p-field">
                <label>
                  <p-checkbox [(ngModel)]="eC.Parametros" [binary]="true" inputId="binary" (onChange)="onChangeChkEvents()" [disabled]="reportService.workingOnReport"></p-checkbox>
                  Parámetros</label>
              </div>
            </div>
          </div>
        </div>
      </div>
          
          <div class="row">
            <div class="col p-field">
              <label class="row ">
                  <div class="col-12 ">
                      <div class="gl-row-underline">
                        <label></label>
                      </div>
                  </div>
              </label>
            </div>
          </div>
          <br>

          
          <div class="row">
            <div class="col p-field">
              <label class="row">
                <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  <label>Intervalo:</label>
                </div>
          
                <div class="col-3">
                  <div class="gl-row-underline">
                    <p-dropdown
                      [options]="pDropdownIntervalos"
                      [(ngModel)]="form.intervalo"
                      name="intervalo"
                      required
                      #intervalo="ngModel"
                      [showClear]="false"
                      optionLabel="label"
                      optionValue="value"
                      [styleClass]="'bg-subtitle'"
                    ></p-dropdown>
                    <small class="text-danger" *ngIf="intervalo.invalid && intervalo.touched">
                      Este campo es obligatorio.
                    </small>
                  </div>
                </div>
          
                <div class="col-3">
                  <div class="p-field gl-row-underline">
                    <p-calendar
                      [(ngModel)]="form.intervalo_hora"
                      name="intervalo_hora"
                      required
                      #intervaloHora="ngModel"
                      [timeOnly]="true"
                      [appendTo]="'body'"
                      [disabled]="false"
                    ></p-calendar>
                    <small class="text-danger" *ngIf="intervaloHora.invalid && intervaloHora.touched">
                      Debe seleccionar una hora.
                    </small>
                  </div>
                </div>
          
                <div class="col-3">
                  <label><em> El reporte se enviará todas las mañanas a la hora elegida </em></label>
                </div>
              </label>
            </div>
          </div>
          


          <div class="row"  *ngIf="this.form.intervalo == 'semanal'">
            <div class="col p-field">
              <label class="row ">
                  <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  </div>
                  <div class="col-3 ">
                      <div class="gl-row-underline">
                          <p-dropdown [options]="pDropdownDiasSemana" [(ngModel)]="form.periodo_dias_semanal" [showClear]="false" optionLabe="label" optionValue="value" [styleClass]="'bg-subtitle'" ></p-dropdown>
                      </div>
                  </div>     
                  <div class="col-6">
                  </div>
              </label>
            </div>
          </div>

          <div class="row" *ngIf="this.form.intervalo == 'mensual'">
            <div class="col p-field">
              <label class="row ">
                  <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label>Periódo días:</label>
                  </div>
                  <div class="col-3 ">
                      <div class="gl-row-underline">
                          <p-dropdown [options]="pDropdownDiasMes" [(ngModel)]="form.periodo_dias_mensual" [showClear]="false" optionLabe="label" optionValue="value" [styleClass]="'bg-subtitle'" ></p-dropdown>
                      </div>
                  </div>     
                  <div class="col-6">
                  </div>
              </label>
            </div>
          </div>



          <div class="row">
            <div class="col p-field">
              <label class="row ">
                  <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                    <label>Formatos disponibles:</label>
                  </div>
                  <div class="col-3 ">
                      <div class="gl-row-underline">
                          <p-dropdown [options]="pDropdownFormatoExport" [(ngModel)]="form.formato_exportacion" [showClear]="false" optionLabe="label" optionValue="value" [styleClass]="'bg-subtitle'" ></p-dropdown>
                      </div>
                  </div>     
                  <div class="col-6">
                  </div>
              </label>
            </div>
          </div>

          <br>

          <div class="row">
            <div class="col p-field">
              <label class="row">
                <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  <label>Recibir reporte:</label>
                </div>
                <div class="col-9">
                    <p-checkbox
                      inputId="binary"
                      [binary]="true"
                      [(ngModel)]="form.notificacion_email"
                    ></p-checkbox>
                </div>
              </label>
            </div>
          </div>


          <div class="row">
            <div class="col p-field">
              <label class="row">
                <div class="col-3 d-flex align-items-center justify-content-start text-start fw-bold">
                  <label>Lista e-mails:</label>
                </div>
                <div class="col-9">
                  <div class="gl-row-underline d-flex">
                    <input
                      type="text"
                      size="70"
                      placeholder="correo-1@mail.com,correo-2@mail.com..."
                      pInputText
                      [disabled]="!form.notificacion_email"
                      [(ngModel)]="form.notificacion_email_lista"
                    />
                    <button 
                      class="btn btn-primary ms-2 d-flex align-items-center justify-content-center"
                      style="width: 35px; height: 35px; border-radius: 50%;"
                      [disabled]="!form.notificacion_email"
                      (click)="addEmail()"
                    >
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                  <div class="form-group row">
                    <div class="col-9">
                      <div class="text">
                        <ul>
                          <li
                            *ngFor="
                              let email of alertForm.value.lista_emails;
                              let i = index
                            "
                            ng-bind-html-unsafe="opt"
                          >
                            {{ email }}
                            <i
                              class="ms-1 fa fa-minus-circle"
                              (click)="restEmail(i)"
                              type="button"
                              data-placement="bottom"
                              aria-hidden="true"
                            ></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div class="row"></div>
         <br>
         <br>
         <br>





    </ng-template>

    <ng-template pTemplate="footer">
      <p-button label="Guardar" icon="pi pi-check" (click)="guardarReporteProgramado();"></p-button>
      <p-button label="Cancelar" icon="pi pi-times" (click)="cancelarReporteProgramado();" styleClass="p-button-secondary" [style]="{ 'margin-left': '.5em' }"></p-button>
    </ng-template>
</p-dialog>
